
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class TipologieProdottiDialog extends Serenity.EntityDialog<TipologieProdottiRow, any> {
        protected getFormKey() { return TipologieProdottiForm.formKey; }
        protected getIdProperty() { return TipologieProdottiRow.idProperty; }
        protected getLocalTextPrefix() { return TipologieProdottiRow.localTextPrefix; }
        protected getNameProperty() { return TipologieProdottiRow.nameProperty; }
        protected getService() { return TipologieProdottiService.baseUrl; }
        protected getDeletePermission() { return TipologieProdottiRow.deletePermission; }
        protected getInsertPermission() { return TipologieProdottiRow.insertPermission; }
        protected getUpdatePermission() { return TipologieProdottiRow.updatePermission; }

        protected form = new TipologieProdottiForm(this.idPrefix);

    }
}